import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { SolicitudService } from './solicitud.service';
import { SolicitudViewModel } from './solicitud.types';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { Tc, TTasaViewModel, TcPaisUsaCodigoPostal, EnumIdsTcPais } from '../../../core/_infrastructure/types/common';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
// import { CustomValidator } from '../../../core/_infrastructure/classes/customValidator';
import {
    EnumIdsTcTipoSolicitud,
    EnumIdsTcTipoMedioTransporte,
    EnumIdsTwTcTipoClonacion,
    EnumIdsTcEstadoSolicitud,
    EnumIdsTcTipoPuntoInspeccion,
} from '../../../_importacion/solicitudes/types/enum';
import { PuntoInspeccionService } from '../puntosinspeccion/puntoinspeccion.service';
import { HttpParams } from '@angular/common/http';
import { TwFinalizacionTrasladoViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';

@Component({
    selector: 'app-solicitud-edit',
    templateUrl: './solicitud-edit.component.html',
})
export class SolicitudEditComponent extends ComponentBase implements OnInit {
    readonly DEC_SUMARIA_AEROPUERTO: number = 39;
    readonly DEC_SUMARIA_PUERTO: number = 16;
    maxlenghtDecSumaria: number = this.DEC_SUMARIA_AEROPUERTO;

    editMode = false;
    editTitle = 'Nueva';
    solicitud: SolicitudViewModel;
    tituloTipoSolicitud: string;
    tituloEstadoSolicitud: string;
    codigoTipoSolicitud: string;

    // esImportadorExtranjero: boolean | null = false;
    esCanarias = false;
    esPredua = false;
    esPrevia = false;
    esAeropuerto = false;
    esClonada = false;

    IdPuntoInspeccion: number;

    paisRequiredMedioTransporte: boolean | null = false;
    usaCodigoPostalPaisImportador = true;
    usaCodigoPostalPaisExportador = true;
    habilitarGuardar = true;
    campoObligatorio = true;

    IdTipoPuntoInspeccion: number | null;

    // listPaisImportador: TcPaisUsaCodigoPostal[];
    listPais: TcPaisUsaCodigoPostal[];
    listMedioTransporte: Tc[];
    listEstadoSolicitud: Tc[];
    listAduana: Tc[];
    listUbicacion: Tc[];
    listIntervalo: Tc[];

    visibilitySpinnerGuardar = false;

    showWindowChedPpTraslado = false;

    public isCollapsedDatosSolicitud = false;
    public isCollapsedTasas = false;
    public isCollapsedExportador = false;
    // public isCollapsedImportador = false;
    // public isCollapsedImportadorExtr = false;
    public isCollapsedLugaresMercancia = false;
    public isCollapsedMediosTransporte = false;
    public isCollapsedCHEDPP = false;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        private puntoInspeccionService: PuntoInspeccionService,
        private solicitudService: SolicitudService,
        protected authService: AuthService,
        protected notificationService: NotificationService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);

        this.solicitud = new SolicitudViewModel();
        this.solicitud.TTasaCollection = new Array<TTasaViewModel>();
    }

    ngOnInit() {
        this.globalService.getEstadoSolicitud().subscribe(res => {
            this.listEstadoSolicitud = res;
        });
        this.globalService.getTipoMedioTransporte().subscribe(res => {
            this.listMedioTransporte = res;
        });

        this.createForm();

        let id = +this.activatedRoute.snapshot.params['id'];

        if (id) {
            this.editMode = true;
            this.editTitle = 'Editar';

            this.solicitudService.getSolicitud(id).subscribe(result => {
                this.solicitud = result;

                //en mantenimiento no pintamos el pto de inspección, así­ que se asigna a variable desde la solicitud
                this.IdPuntoInspeccion = this.solicitud.IdPuntoInspeccion;

                this.globalService.getAduanaByPuntoInspeccion(this.solicitud.IdPuntoInspeccion).subscribe(res => {
                    this.listAduana = res;
                });

                let params = new HttpParams();
                params = params.append('id', this.solicitud.IdPuntoInspeccion.toString());
                params = params.append('esimportacion', 'true');
                this.globalService.getUbicacionByPuntoInspeccion(params).subscribe(res => {
                    this.listUbicacion = res;
                });

                this.globalService.getIntervaloHorasByPuntoInspeccion(this.solicitud.IdPuntoInspeccion).subscribe(res => {
                    this.listIntervalo = res;
                });

                // this.esImportadorExtranjero = this.solicitud.EsExtranjero;
                this.esCanarias = this.solicitud.TcTipoSolicitud.Id == EnumIdsTcTipoSolicitud.ID_CANARIAS;
                this.esPredua = this.solicitud.TwTcSubTipoSolicitud != null && this.solicitud.TwTcSubTipoSolicitud.EsPreDua;
                this.esClonada =
                    this.solicitud.TwSolicitudJerarquia != null && this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_CLONACION
                        ? true
                        : false;
                this.paisRequiredMedioTransporte = this.solicitud.TMedioTransporte.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;

                this.tituloTipoSolicitud = this.solicitud.TcTipoSolicitud.Descripcion;
                this.codigoTipoSolicitud = this.solicitud.TcTipoSolicitud.Codigo;
                this.tituloEstadoSolicitud = this.solicitud.TcEstadoSolicitud.Descripcion;

                //Si es importador extranjero no valido NRegistro, pongo obligatorio el País del importador
                /*
                if (this.esImportadorExtranjero) {
                    this.addValidator('Nombre', Validators.required);
                    this.removeValidators('NRegistro');
                    this.addValidator('IdPaisImportador', Validators.required);
                } else {
                    this.addValidator('NIF', CustomValidator.NIFValidator);
                }
                    */

                //Si es PREDUA valido Mrn y elimino validaciones
                if (this.esPredua) {
                    this.addValidator('Mrn', Validators.required);
                    this.addValidator('Mrn', Validators.minLength(18));
                    this.addValidator('Mrn', Validators.maxLength(18));
                    this.removeValidators('NumeroDeclaracionSumaria');
                }

                this.updateForm();

                //Si es solicitud de CANARIAS
                if (this.esCanarias) {
                    this.form.patchValue({
                        IdPaisProcedencia: EnumIdsTcPais.ID_ESPANA,
                    });
                    this.form.controls['IdPaisProcedencia'].disable();
                }

                //SI ES PREVIA
                if (this.esPrevia) {
                    if (
                        this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA &&
                        this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_PENDIENTE
                    ) {
                        this.tituloTipoSolicitud += ' - Previa';
                    }

                    //Si ya la ha aceptado el inspector hay que validar como si ya no fuera PREVIA
                    if (
                        this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA
                        /*&& this.solicitud.Codigo == null*/
                    ) {
                        this.RemoveValidationsPrevia();
                        this.campoObligatorio = false;
                    }
                }

                //Se comprueba si es una solicitud de tipo "Normal" que finaliza "Traslado" en estado "Borrador" o "Revisión solicitante"
                this.conditionsToShowWindowChedPpTraslado();
            });
        }
    }

    createForm() {
        this.form = this.fb.group({
            Codigo: ['', Validators.required],
            IdEstadoSolicitud: [null, Validators.min(1)],
            TotalTasas: '',
            FechaLiquidacion: '',
            NumeroLiquidacion: '',
            NombreExportador: '',
            IdPaisExportador: [null, Validators.min(1)],
            CiudadExportador: '',
            DireccionExportador: '',

            // Importador
            // NIF: ['', Validators.compose([Validators.required])], //, CustomValidator.NIFValidator
            // NRegistro: '',
            // Nombre: '',
            // Direccion: '',
            // Localidad: ['', Validators.required],
            // CodigoPostalImportador: ['', Validators.required],
            // IdPaisImportador: null,
            // RefTraces: '',
            // TipoRefTraces: '',
            // OperadorTraces: '',
            // TipoOperador: '',

            //exportador
            CodigoPostalExportador: ['', Validators.required],

            //lugares referentes a la mercancía
            IdPaisOrigen: [null, Validators.required],
            IdPaisProcedencia: [null, Validators.required],
            IdPaisDestino: [null, Validators.required],
            IdAduana: null,
            IdUbicacion: [null, Validators.required],
            FechaInspeccion: ['', Validators.required],
            IdIntervaloHoras: null,

            //medios transporte
            IdMedioTransporte: [null, Validators.required],
            NumeroDeclaracionSumaria: [null, Validators.required],
            Mrn: null,
            FechaLlegada: ['', Validators.required],
            NumeroOMI: [null, Validators.required],
            IdPaisMedioTransporte: null,

            //CHEDPP solicitudes "Normales" que finalizan "Traslado"
            ChedPpTraslado: '',
        });
    }

    updateForm() {
        this.form.setValue({
            Codigo: this.solicitud.Codigo,
            IdEstadoSolicitud: this.solicitud.IdEstadoSolicitud,
            TotalTasas: '',
            FechaLiquidacion: '',
            NumeroLiquidacion: '',
            NombreExportador: this.solicitud.TExportador.NombreExportador,
            IdPaisExportador: this.solicitud.TExportador.IdPaisExportador,
            CiudadExportador: this.solicitud.TExportador.CiudadExportador,
            DireccionExportador: this.solicitud.TExportador.DireccionExportador,
            CodigoPostalExportador: this.solicitud.TExportador.CodigoPostalExportador,

            //importador
            /*
            NIF: this.solicitud.TImportador?.Nif,
            NRegistro: this.solicitud.TImportador?.NRegistro,
            Nombre: this.solicitud.TImportador?.Nombre,
            Direccion: this.solicitud.TImportador?.Direccion,
            IdPaisImportador: this.solicitud.TImportador?.IdPaisImportador,
            Localidad: this.solicitud.TImportador?.Localidad,
            CodigoPostalImportador: this.solicitud.TImportador?.CodigoPostalImportador,
            RefTraces: this.solicitud.TImportador?.RefTraces,
            TipoRefTraces: this.solicitud.TImportador?.TipoRefTraces,
            OperadorTraces: this.solicitud.TImportador?.OperadorTraces,
            TipoOperador: this.solicitud.TImportador?.TipoOperador,
            */

            //lugares referente mercancía
            IdPaisOrigen: this.solicitud.TLugarMercancia.IdPaisOrigen,
            IdPaisProcedencia: this.solicitud.TLugarMercancia.IdPaisProcedencia,
            IdPaisDestino: this.solicitud.TLugarMercancia.IdPaisDestino,
            IdAduana: this.solicitud.TLugarMercancia.IdAduana,
            IdUbicacion: this.solicitud.TLugarMercancia.IdUbicacion,
            FechaInspeccion: this.solicitud.TLugarMercancia.FechaInspeccion != null ? new Date(this.solicitud.TLugarMercancia.FechaInspeccion) : null,
            IdIntervaloHoras: this.solicitud.TLugarMercancia.IdIntervaloHoras,

            //medio transporte
            IdMedioTransporte: this.solicitud.TMedioTransporte.IdMedioTransporte,
            NumeroDeclaracionSumaria: this.solicitud.TMedioTransporte.NumeroDeclaracionSumaria,
            Mrn: this.solicitud.TMedioTransporte.Mrn,
            FechaLlegada: this.solicitud.TMedioTransporte.FechaLlegada != null ? new Date(this.solicitud.TMedioTransporte.FechaLlegada) : '',
            NumeroOMI: this.solicitud.TMedioTransporte.NumeroOMI,
            IdPaisMedioTransporte: this.solicitud.TMedioTransporte.IdPaisMedioTransporte,

            //CHEDPP solicitudes "Normales" que finalizan "Traslado"
            ChedPpTraslado: '',
        });

        if (
            this.solicitud.TwSolicitudJerarquia !== null &&
            this.solicitud.TwSolicitudJerarquia.IdTipoClonacion == EnumIdsTwTcTipoClonacion.ID_FINALIZA_TRASLADO &&
            this.solicitud.TwFinalizacionTraslado !== null
        ) {
            this.form.patchValue({
                ChedPpTraslado: this.solicitud.TwFinalizacionTraslado.ChedPpTraslado,
            });
        }

        if (!this.esPredua && this.esPrevia && this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA) {
            //Actualizo validaciones del documento aduanero
            this.UpdateDocumentoAduanero(this.solicitud.IdPuntoInspeccion);
        }

        //PAIS MEDIO TRANSPORTE
        if (this.paisRequiredMedioTransporte) {
            this.addValidator('IdPaisMedioTransporte', Validators.required);
        } else {
            this.removeValidators('IdPaisMedioTransporte');
        }

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        /*
        this.globalService.getAllPaisesUeTcUsaCodigoPostal().subscribe(res => {
            this.listPaisImportador = res;

            //PAIS IMPORTADOR
            if (this.esImportadorExtranjero) {
                const idPaisImportador = this.form.controls['IdPaisImportador'].value; //this.form.value.IdPaisImportador;
                let seleccionado = this.listPaisImportador.find(x => x.Id == idPaisImportador);
                if (seleccionado != null) {
                    this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
                } else {
                    this.usaCodigoPostalPaisImportador = false;
                }
                if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
                    this.addValidator('CodigoPostalImportador', Validators.required);
                } else {
                    this.removeValidators('CodigoPostalImportador');
                }
            }
        });
        */

        //hacemos el subscribe manual y no lo delegamos al async del HTML, volcamos a array de objetos para acceder al
        //valor de ciertas columnas al seleccionar un elemento
        this.globalService.getAllPaisesTcUsaCodigoPostal().subscribe(res => {
            this.listPais = res;

            //PAIS EXPORTADOR
            const idPaisExportador = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;
            let seleccionado = this.listPais.find(x => x.Id == idPaisExportador);
            if (seleccionado != null) {
                this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
            }
            if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
                this.addValidator('CodigoPostalExportador', Validators.required);
            } else {
                this.removeValidators('CodigoPostalExportador');
            }
        });
    }

    onAddTasa() {
        this.removeValidators('TotalTasas');
        this.addValidator('TotalTasas', Validators.required);
        this.addValidator('TotalTasas', Validators.pattern('^[0-9]+([.,][0-9]+)?$'));
        if (this.isFieldInvalidNoSubmit('TotalTasas', 'required') || this.isFieldInvalidNoSubmit('TotalTasas', 'pattern')) {
            return;
        }
        this.removeValidators('TotalTasas');

        this.removeValidators('NumeroLiquidacion');
        this.addValidator('NumeroLiquidacion', Validators.pattern('^[0-9]+([.,][0-9]+)?$'));
        if (this.isFieldInvalidNoSubmit('NumeroLiquidacion', 'pattern')) {
            return;
        }
        this.removeValidators('NumeroLiquidacion');

        if (this.form.value.TotalTasas != '') {
            let tasa = new TTasaViewModel();

            tasa.TotalTasas = this.form.value.TotalTasas;
            tasa.NumeroLiquidacion = this.form.value.NumeroLiquidacion;
            tasa.FechaLiquidacion = this.form.value.FechaLiquidacion;

            //Convierto las comas en puntos
            tasa.TotalTasas = Number(tasa.TotalTasas.toString().replace(',', '.'));

            this.solicitud.TTasaCollection.push(tasa);
        }

        this.form.patchValue({
            TotalTasas: '',
            NumeroLiquidacion: '',
            FechaLiquidacion: '',
        });
    }

    onDeleteTasa(tasa: TTasaViewModel) {
        this.solicitud.TTasaCollection.splice(this.solicitud.TTasaCollection.indexOf(tasa), 1);
    }

    onSelectPaisImportador() {
        const idPais = this.form.controls['IdPaisImportador'].value; //this.form.value.IdPaisImportador;

        let seleccionado = this.listPais.find(x => x.Id == idPais);

        if (seleccionado != null) {
            this.usaCodigoPostalPaisImportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
        }

        if (this.usaCodigoPostalPaisImportador!.valueOf() == true) {
            this.addValidator('CodigoPostalImportador', Validators.required);
        } else {
            this.removeValidators('CodigoPostalImportador');
        }
    }

    onSelectPaisExportador() {
        const idPais = this.form.controls['IdPaisExportador'].value; //this.form.value.IdPaisExportador;

        let seleccionado = this.listPais.find(x => x.Id == idPais);

        if (seleccionado != null) {
            this.usaCodigoPostalPaisExportador = (<TcPaisUsaCodigoPostal>seleccionado).UsaCodigoPostal;
        }

        if (this.usaCodigoPostalPaisExportador!.valueOf() == true) {
            this.addValidator('CodigoPostalExportador', Validators.required);
        } else {
            this.removeValidators('CodigoPostalExportador');
        }
    }

    onSelectTipoMedioTransporte() {
        //Si es previa no se valida nada
        //if (!this.esPrevia && !(this.solicitud.IdEstadoSolicitud != EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA /*&& this.enviada*/)) {
        //TODO: jlht. Consensuado con rdlf el no tener en cuenta el tipo de solicitud, se comprueba para todas
        //if (!(this.esPrevia && this.solicitud.IdEstadoSolicitud == EnumIdsTcEstadoSolicitud.ID_PREVIA_ACEPTADA)) {
        this.paisRequiredMedioTransporte = this.form.value.IdMedioTransporte == EnumIdsTcTipoMedioTransporte.ID_AVION ? false : true;

        if (this.paisRequiredMedioTransporte) {
            this.addValidator('IdPaisMedioTransporte', Validators.required);
        } else {
            this.removeValidators('IdPaisMedioTransporte');
        }
        //}
    }

    private UpdateDocumentoAduanero(idPuntoInspeccion: any) {
        this.removeValidators('NumeroDeclaracionSumaria');
        this.puntoInspeccionService.getPuntoInspeccion(idPuntoInspeccion).subscribe(result => {
            this.IdTipoPuntoInspeccion = result.IdTipoPuntoInspeccion;
            if (result.IdTipoPuntoInspeccion == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('NumeroDeclaracionSumaria', Validators.minLength(18));
                this.addValidator('NumeroDeclaracionSumaria', Validators.maxLength(this.DEC_SUMARIA_AEROPUERTO));
                this.esAeropuerto = true;
                this.maxlenghtDecSumaria = this.DEC_SUMARIA_AEROPUERTO;
            } else {
                this.addValidator('NumeroDeclaracionSumaria', Validators.required);
                this.addValidator('NumeroDeclaracionSumaria', Validators.minLength(this.DEC_SUMARIA_PUERTO));
                this.addValidator('NumeroDeclaracionSumaria', Validators.maxLength(this.DEC_SUMARIA_PUERTO));
                this.esAeropuerto = false;
                this.maxlenghtDecSumaria = this.DEC_SUMARIA_PUERTO;
            }

            this.EstableceMedioTransporte(this.IdTipoPuntoInspeccion);
        });
    }

    private EstableceMedioTransporte(idTipoPif: number | null) {
        if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_AEROPUERTO) {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_AVION,
            });
            //RDLF OJO!!: si deshabilito el campo no se envia en el submit, controlar esto
            //this.form.controls['IdMedioTransporte'].disable();
        } else if (idTipoPif == EnumIdsTcTipoPuntoInspeccion.ID_PUERTO) {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_BARCO,
            });
        } else {
            this.form.patchValue({
                IdMedioTransporte: EnumIdsTcTipoMedioTransporte.ID_VEHICULO,
            });
        }
    }

    private RemoveValidationsPrevia() {
        this.removeValidators('IdPaisExportador');
        this.removeValidators('NombreExportador');
        this.removeValidators('CiudadExportador');
        this.removeValidators('IdPaisOrigen');
        this.removeValidators('IdPaisProcedencia');
        this.removeValidators('IdPaisDestino');
        this.removeValidators('IdUbicacion');
        this.removeValidators('FechaInspeccion');
        this.removeValidators('IdMedioTransporte');
        this.removeValidators('NumeroDeclaracionSumaria');
        this.removeValidators('NumeroOMI');
        // this.removeValidators('NIF');
        // this.removeValidators('Nombre');
        // this.removeValidators('NRegistro');
        this.removeValidators('FechaLlegada');
        // this.removeValidators('Localidad');
        // this.removeValidators('CodigoPostalImportador');
        this.removeValidators('CodigoPostalExportador');
        // this.removeValidators('IdPaisImportador');
        this.removeValidators('IdPaisMedioTransporte');
    }

    saveSolicitud() {
        this.visibilitySpinnerGuardar = true;
        this.onSubmit();
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            this.addErrorMessage('Revise los datos de la solicitud');

            this.isCollapsedDatosSolicitud = false;
            this.isCollapsedExportador = false;
            // this.isCollapsedImportador = false;
            this.isCollapsedTasas = false;
            // this.isCollapsedImportadorExtr = false;
            this.isCollapsedLugaresMercancia = false;
            this.isCollapsedCHEDPP = false;

            this.visibilitySpinnerGuardar = false;

            return;
        }

        let solicitud = new SolicitudViewModel();

        solicitud.Codigo = this.form.value.Codigo;
        solicitud.IdEstadoSolicitud = this.form.value.IdEstadoSolicitud;
        solicitud.IdPuntoInspeccion = this.IdPuntoInspeccion!;

        solicitud.TExportador.NombreExportador = this.form.value.NombreExportador;
        solicitud.TExportador.IdPaisExportador = this.form.value.IdPaisExportador;
        solicitud.TExportador.CiudadExportador = this.form.value.CiudadExportador;
        solicitud.TExportador.DireccionExportador = this.form.value.DireccionExportador;
        solicitud.TExportador.CodigoPostalExportador = this.form.value.CodigoPostalExportador;

        /*
        solicitud.TImportador.Nif = this.form.value.NIF;
        solicitud.TImportador.NRegistro = this.form.value.NRegistro;
        solicitud.TImportador.Nombre = this.form.value.Nombre;
        solicitud.TImportador.Direccion = this.form.value.Direccion;
        solicitud.TImportador.IdPaisImportador = this.esImportadorExtranjero
            ? this.form.value.IdPaisImportador
            : (solicitud.TImportador.IdPaisImportador = EnumIdsTcPais.ID_ESPANA);
        solicitud.TImportador.Localidad = this.form.value.Localidad;
        solicitud.TImportador.CodigoPostalImportador = this.form.value.CodigoPostalImportador;

        solicitud.TImportador.RefTraces = this.form.value.RefTraces;
        solicitud.TImportador.TipoRefTraces = this.form.value.TipoRefTraces;
        solicitud.TImportador.OperadorTraces = this.form.value.OperadorTraces;
        solicitud.TImportador.TipoOperador = this.form.value.TipoOperador;
        */
        solicitud.TTasaCollection = this.solicitud.TTasaCollection;

        solicitud.TLugarMercancia.IdPaisOrigen = this.form.value.IdPaisOrigen;
        solicitud.TLugarMercancia.IdPaisProcedencia = this.esCanarias ? EnumIdsTcPais.ID_ESPANA : this.form.value.IdPaisProcedencia;
        solicitud.TLugarMercancia.IdPaisDestino = this.form.value.IdPaisDestino;
        solicitud.TLugarMercancia.IdAduana = this.form.value.IdAduana;
        solicitud.TLugarMercancia.IdUbicacion = this.form.value.IdUbicacion;
        solicitud.TLugarMercancia.FechaInspeccion = this.form.value.FechaInspeccion;
        solicitud.TLugarMercancia.IdIntervaloHoras = this.form.value.IdIntervaloHoras;

        solicitud.TMedioTransporte.IdMedioTransporte = this.form.value.IdMedioTransporte;
        solicitud.TMedioTransporte.NumeroOMI = this.form.value.NumeroOMI;
        solicitud.TMedioTransporte.FechaLlegada = this.form.value.FechaLlegada;
        solicitud.TMedioTransporte.NumeroDeclaracionSumaria = this.form.value.NumeroDeclaracionSumaria;
        solicitud.TMedioTransporte.IdPaisMedioTransporte = this.form.value.IdPaisMedioTransporte;

        solicitud.TMedioTransporte.Mrn = this.form.value.Mrn;

        if (this.solicitud.TwFinalizacionTraslado !== null) {
            solicitud.TwFinalizacionTraslado = new TwFinalizacionTrasladoViewModel();
            solicitud.TwFinalizacionTraslado.ChedPpTraslado = this.solicitud.TwFinalizacionTraslado.ChedPpTraslado;
        }
        if (this.showWindowChedPpTraslado) {
            //solicitud.TwFinalizacionTraslado = new TwFinalizacionTrasladoViewModel();
            solicitud.TwFinalizacionTraslado.ChedPpTraslado = this.form.value.ChedPpTraslado;
        }

        solicitud.Id = this.solicitud.Id;

        if (this.editMode) {
            this.solicitudService.editSolicitud(solicitud).subscribe({
                next: () => {
                    this.visibilitySpinnerGuardar = false;
                    this.addSuccessMessage('Solicitud modificada correctamente');
                    this.onBack();
                },
                error: error => {
                    this.visibilitySpinnerGuardar = false;
                    this.catchServerError(error);

                    this.isCollapsedDatosSolicitud = false;
                    this.isCollapsedExportador = false;
                    // this.isCollapsedImportador = false;
                    this.isCollapsedTasas = false;
                    // this.isCollapsedImportadorExtr = false;
                    this.isCollapsedLugaresMercancia = false;
                    this.isCollapsedMediosTransporte = false;
                    this.isCollapsedCHEDPP = false;
                },
            });
        }
    }

    conditionsToShowWindowChedPpTraslado(): void {
        if (
            (this.solicitud.IdEstadoSolicitud === EnumIdsTcEstadoSolicitud.ID_BORRADOR ||
                this.solicitud.IdEstadoSolicitud === EnumIdsTcEstadoSolicitud.ID_REVISION_SOLICITANTE) &&
            this.solicitud.IdTipoSolicitud === EnumIdsTcTipoSolicitud.ID_NORMAL &&
            this.solicitud.TwSolicitudJerarquia !== null &&
            this.solicitud.TwSolicitudJerarquia.IdTipoClonacion === EnumIdsTwTcTipoClonacion.ID_FINALIZA_TRASLADO
        ) {
            this.showWindowChedPpTraslado = true;
        } else {
            this.showWindowChedPpTraslado = false;
        }
    }

    onBack() {
        this.router.navigate(['/mantenimiento/general/solicitudes']);
    }
}
